export default "<div class=\"users-count-container\">\n  <img src=\"images/icons/users.svg\" alt=\"Users\" />\n  <span class=\"users-count\"></span>\n</div>\n";